import { LayoutCss } from './../layout-css/layout-css';
import { Municipio } from './../../enderecamento/municipio/municipio';
import { Resource } from '../../../common/resource.model';
import { TipoLogradouro } from '../../enderecamento/tipo-logradouro/tipo-logradouro';

export class Entidade extends Resource {
    cnpj: string;
    nomeApresentacao: string;
    razaoSocial: string;
    tipoLogradouro:TipoLogradouro;
    logradouro: string;
    numero: string;
    complemento: string;
    bairro : string;
    cep: string;
    municipio: Municipio;
    telefone: string;
    site: string;
    email: string;
    ativo: boolean;
    layoutCss: LayoutCss;
    previdencia: boolean;
}